/**
 * Don't pick a view while SprintDetail is still showing the campaign we're
 * leaving. That list doesn't contain the destination's Board view, the pick
 * misses, and Flow gets chosen before the real campaign arrives.
 */
export function viewRestoreGate({ localCampaignId, targetCampaignId, viewsReady }) {
  if (
    targetCampaignId &&
    localCampaignId &&
    targetCampaignId !== localCampaignId
  ) {
    return 'defer';
  }
  if (!viewsReady) return 'defer';
  return 'ready';
}

/**
 * What to open when a tab comes back.
 * A remembered Board view wins over a leftover Flow request. An explicit
 * request for some other view (a link, a different tab) still wins.
 */
export function resolveRestoredRequest({ remembered, requested }) {
  const requestedId = requested && typeof requested === 'object' ? requested.customViewId : null;
  const requestedType = typeof requested === 'string'
    ? requested
    : (requested?.type || null);

  if (!remembered?.id) return requested || null;

  if (requestedId && requestedId === remembered.id) return requested;
  if (requestedId && requestedId !== remembered.id) return requested;

  if (requestedType && requestedType === remembered.type) {
    return { customViewId: remembered.id, type: remembered.type, skipUrlUpdate: true };
  }

  if ((!requestedType || requestedType === 'flow') && remembered.type && remembered.type !== 'flow') {
    return { customViewId: remembered.id, type: remembered.type, skipUrlUpdate: true };
  }

  return requested || null;
}

/** The view row to select, or null when the requested one isn't in the list yet. */
export function chooseRestoredView({ remembered, requested, views }) {
  const list = Array.isArray(views) ? views : [];
  const request = resolveRestoredRequest({ remembered, requested });
  const byId = (id) => list.find((view) => view?.id === id) || null;
  const byType = (type) => list.find((view) => view?.type === type) || null;

  const requestId = request && typeof request === 'object' ? request.customViewId : null;
  const requestType = typeof request === 'string' ? request : (request?.type || null);

  if (requestId && byId(requestId)) return byId(requestId);
  if (requestType && byType(requestType)) return byType(requestType);
  // A named view that isn't loaded yet must not be replaced with Flow.
  if (requestId || (requestType && requestType !== 'flow')) return null;
  return byType('flow') || list[0] || null;
}
